import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
  text-decoration: underline;
  cursor: pointer;
`

export const s = { Container }
